import React from "react";
import { useQuery } from "react-query";
import { getOfficeAccount } from "../../../../../actions/Utilities/OfficeAccount";

export default function useGetOfficeAccount() {
  return useQuery("GetOfficeAccount", getOfficeAccount, {
    refetchOnWindowFocus: false,
  });
}
